import { createAction } from "redux-act";
import { ThemeName } from "@evergis/ui";

export const changeThemeName = createAction<ThemeName>("theme/change-theme-name");
